export const projectInitialState = {
    // get
    projects: [],
    isLoadingProjects: false,
    // view
    projectDetails: null,
    isLoadingDetails: false,
    // create
    isUploading: false,
    // edit
    isUpdatingProject: false,
    error: null
}
